export { default } from './search-landing-page';